export const isExperimental =
  import.meta.env.VITE_EXPERIMENTAL_ENABLED === 'true';
